import { usePatientSelectionContext } from '@context/PatientSelection';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useEffect } from 'react';
import { PATIENT_SELECTION_VIEW } from '../focuskey';

import ButtonContainer from './components/ButtonContainer';
import Content from './components/Content';

import * as styles from './styles';

const PatientSelectionView = () => {
  const { setFirstItemFocus } = usePatientSelectionContext();

  const { ref } = useFocusable({ focusKey: PATIENT_SELECTION_VIEW });

  useEffect(() => {
    setFirstItemFocus();
  }, [setFirstItemFocus]);

  return (
    <FocusContext.Provider value={PATIENT_SELECTION_VIEW}>
      <div ref={ref} css={styles.container}>
        <Content />
        <ButtonContainer />
      </div>
    </FocusContext.Provider>
  );
};

export default PatientSelectionView;
